import { misc } from "@otto-ec/global-resources/misc"

const pageClusterMapping: Record<string, string> = {
    MYA_Dashboard: "MyAccountOverview",
    MYA_Orders: "MyOrder",
    MYA_Invoices: "Invoices",
    MYA_Balance: "MyBookings",
    MYA_UP: "Up",
    MYA_UP_Points: "MyUpPoints",
    MYA_UP_Membership: "MyUpMembership",
    MYA_Profile: "Profile",
    MYA_Profile_Data: "MyData",
    MYA_Profile_Permissions: "mysettings_permissions",
    MYA_Profile_Security: "Security",
    MYA_Licenses: "LicensesPage",
    AftersalesOrders: "PositionDetailPage",
    Paymentinfo: "PaymentDetailPage",
}

export function determinePageCluster(): string | null {
    try {
        const cluster = misc.getPagecluster()
        if (cluster && pageClusterMapping[cluster]) {
            return pageClusterMapping[cluster]
        }
        return cluster
    } catch {
        return null
    }
}
